import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// Mark JS as enabled only after the bundle is actually executing.
// This keeps the static fallback visible by default for no-JS crawlers.
document.documentElement.classList.add("js-enabled");

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
